// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__4bU1a","selected":"Tab_selected__Jm+zr"};